import(/* webpackMode: "eager" */ "/codebuild/output/src750483383/src/apps/web/app/[locale]/error.tsx");
